import { toggleScroll } from "./toggleScroll";
import { formatNumber } from "./formatNumber";
import { shortenTitle, stringShortner } from "./stringShortner";
import { errorMessage } from "./toast";
import getLanguageFromUrl from "./getLanguageFromUrl";
import getUnixTimeStamp from "./getUnixTimeStamp";
import formatNum from "./formatNum";
import { formatLargeNum } from "./formatLargeNum";
import { animateDisplay } from "./animateDisplay";
import { convertMsToHM } from "./convertMsToHM";
import { timeSince } from "./timeSince";
import showDollar from "./showDollar";
import { generateSymbol } from "./generateSymbol";
import removeUnderScore from "./removeUnderScore";
import copyText from "./copyText";
import convertEpochToFormattedDate from "./convertEpoch";
import { scrollTo } from "./scrollTo";
import { formatMatches, formatCompetitons } from "./formatMatches";
import { getPoolStage } from "./getPoolStage";
import truncateHash from "./truncateHash";
import { hearAboutOptions } from "./selectField";
import { formatURL, formatDate } from "./formatUrl";
import { FAQs, footerNavItems } from "./faq";
import { formatPrice } from "./formatPrice";
import { firstSlider, secondSlider } from "./animate";
import { getBlogPosts, getEntryBySlug, getBlogPostByTitle } from "./contentful";

export {
	toggleScroll,
	formatNumber,
	stringShortner,
	errorMessage,
	getUnixTimeStamp,
	getLanguageFromUrl,
	formatNum,
	formatLargeNum,
	animateDisplay,
	convertMsToHM,
	timeSince,
	showDollar,
	generateSymbol,
	removeUnderScore,
	copyText,
	convertEpochToFormattedDate,
	shortenTitle,
	scrollTo,
	formatMatches,
	formatCompetitons,
	getPoolStage,
	truncateHash,
	hearAboutOptions,
	formatURL,
	FAQs,
	footerNavItems,
	formatPrice,
	firstSlider,
	secondSlider,
	getBlogPosts,
	getEntryBySlug,
	getBlogPostByTitle,
	formatDate,
};
